/* LYTEXA Color Lab 2.0.1 — Stable Shopify Login, no credits system */

(() => {
  'use strict';

  const DEFAULT_PALETTE = [
    '#00aeef',
    '#ec008c',
    '#fff200',
    '#000000',
    '#e0e6ed',
    '#00f5d4',
    '#a0a0a0',
    '#ffd1dc'
  ];

  class LytexaColorLab {
    constructor(root) {
      this.root = root;

      this.statusElement = root.querySelector(
        '[data-color-lab-status]'
      );

      this.workspaceElement = root.querySelector(
        '[data-color-lab-workspace]'
      );

      this.canvas = root.querySelector(
        '[data-color-lab-canvas]'
      );

      this.colorsElement = root.querySelector(
        '[data-color-lab-colors]'
      );

      this.mobilePicker =
          root.querySelector(
              '[data-color-lab-mobile-picker]'
          );

      this.mobilePickerHost =
          root.querySelector(
              '[data-color-lab-mobile-picker-host]'
          );

      this.mobileClose =
          root.querySelector(
              '[data-color-lab-mobile-close]'
          );

      this.productTitleElement = root.querySelector(
        '[data-color-lab-product-title]'
      );

      this.productNumberElement = root.querySelector(
        '[data-color-lab-product-number]'
      );

      this.resetButton = root.querySelector(
        '[data-color-lab-reset]'
      );

      this.downloadButton = root.querySelector(
        '[data-color-lab-download]'
      );

      this.randomButton = root.querySelector(
        '[data-color-lab-random]'
      );

      this.saveMessage = root.querySelector(
        '[data-color-lab-save-message]'
      );

      this.productActions = root.querySelector(
        '[data-color-lab-product-actions]'
      );

      this.licenseLink = root.querySelector(
        '[data-color-lab-license-link]'
      );

      this.backLink = root.querySelector(
        '[data-color-lab-back-link]'
      );

      this.inspirationControl = root.querySelector(
        '[data-color-lab-inspiration-control]'
      );

      this.inspirationPicker = root.querySelector(
        '[data-color-lab-inspiration-picker]'
      );

      this.inspirationButton = root.querySelector(
        '[data-color-lab-inspiration-button]'
      );

      this.inspirationLabel = root.querySelector(
        '[data-color-lab-inspiration-label]'
      );

      this.inspirationMenu = root.querySelector(
        '[data-color-lab-inspiration-menu]'
      );

      this.inspirationGenerateButton = root.querySelector(
        '[data-color-lab-inspiration-generate]'
      );

      this.colorRangeInput = root.querySelector(
        '[data-color-lab-range]'
      );

      this.colorRangeValue = root.querySelector(
        '[data-color-lab-range-value]'
      );

      this.saturationInput = root.querySelector(
        '[data-color-lab-saturation]'
      );

      this.saturationValue = root.querySelector(
        '[data-color-lab-saturation-value]'
      );

      this.lightnessInput = root.querySelector(
        '[data-color-lab-lightness]'
      );

      this.lightnessValue = root.querySelector(
        '[data-color-lab-lightness-value]'
      );

      this.mobilePicker = root.querySelector(
        '[data-color-lab-mobile-picker]'
      );

      this.mobilePickerHost = root.querySelector(
        '[data-color-lab-mobile-picker-host]'
      );

      this.mobileClose = root.querySelector(
        '[data-color-lab-mobile-close]'
      );

      this.activeMobileColorIndex = null;
      this.activeColorIndex = 0;
      this.isolatedLayerIndex = null;
      this.holdDelay = 350;
      this.mobileHue = 0;
      this.mobileSaturation = 1;
      this.mobileValue = 1;

      this.productHandle = '';
      this.productTitle = '';
      this.designNumber = '';

      this.context = this.canvas
        ? this.canvas.getContext('2d')
        : null;

      this.layers = [];
      this.effectLayer = null;
      this.effectEnabled = false;
      this.colors = [];
      this.initialColors = [];
      this.rangeBaseColors = [];
      this.colorRangeDegrees = 0;
      this.saturationAdjustment = 0;
      this.lightnessAdjustment = 0;

      this.handleReset =
        this.handleReset.bind(this);

      this.handleDownload =
        this.handleDownload.bind(this);

      this.handleInspirationGenerate =
        this.handleInspirationGenerate.bind(this);

      this.handleColorRangeInput =
        this.handleColorRangeInput.bind(this);

      this.handleSaturationInput =
        this.handleSaturationInput.bind(this);

      this.handleLightnessInput =
        this.handleLightnessInput.bind(this);

      this.handleLicenseClick =
        this.handleLicenseClick.bind(this);

      this.inspirationTheme = 'random';
      this.lastInspirationKey = '';
      this.openInspirationGroup = '';
      this.inspirationThemes = this.getInspirationThemes();

    }

    async initialize() {
      try {
        this.validateElements();

        const productHandle =
          this.getProductHandle();

        this.productHandle = productHandle;

        if (!productHandle) {
          throw new Error(
            'No design was selected. Please open the Color Lab from a product page.'
          );
        }

        const product =
          await this.loadProductData(
            productHandle
          );

        if (
          !product.available ||
          !Array.isArray(product.separations) ||
          product.separations.length === 0
        ) {
          throw new Error(
            'No Color Lab separations are available for this design.'
          );
        }

        this.productTitle = product.title || '';
        this.designNumber =
          product.design_number ||
          product.designNumber ||
          '';

        if (this.productTitleElement) {
          this.productTitleElement.textContent =
            this.productTitle;
        }

        if (this.productNumberElement) {
          this.productNumberElement.textContent =
            this.designNumber;

          this.productNumberElement.hidden =
            !this.designNumber;
        }

        this.layers =
          await this.loadImages(
            product.separations
          );

        if (product.effect?.url) {
          this.effectLayer =
            await this.loadEffectImage(
              product.effect.url
            );

          this.effectEnabled = true;
        }

        const initialPalette =
          this.createInitialPalette(
            this.layers.length
          );

        this.colors = [
          ...initialPalette
        ];

        this.initialColors = [
          ...initialPalette
        ];

        this.setColorRangeBase(initialPalette, true);

        this.prepareCanvas();
        this.createColorControls();
        this.createMobilePicker();
        this.ensureInspirationControls();
        this.ensureActionButtonLayout();
        this.bindEvents();
        this.updateProductLinks(productHandle);
        this.render();

        this.statusElement.hidden = true;
        this.workspaceElement.hidden = false;

        /*
        |--------------------------------------------------------------------------
        | Anfangspalette an AI und Color Library melden
        |--------------------------------------------------------------------------
        */

        this.notifyPaletteChange();
      } catch (error) {
        console.error(
          'LYTEXA Color Lab:',
          error
        );

        this.showError(
          error.message ||
          'The Color Lab could not be loaded.'
        );
      }
    }

    validateElements() {
      if (
        !this.statusElement ||
        !this.workspaceElement ||
        !this.canvas ||
        !this.context ||
        !this.colorsElement
      ) {
        throw new Error(
          'The Color Lab interface is incomplete.'
        );
      }
    }

    bindEvents() {
      if (this.resetButton) {
        this.resetButton.addEventListener(
          'click',
          this.handleReset
        );
      }

      if (this.downloadButton) {
        this.downloadButton.addEventListener(
          'click',
          this.handleDownload
        );
      }


      if (this.licenseLink) {
        this.licenseLink.addEventListener(
          'click',
          this.handleLicenseClick
        );
      }

      if (this.inspirationButton) {
        this.inspirationButton.addEventListener('click', () => {
          this.toggleInspirationMenu();
        });
      }

      if (this.inspirationMenu) {
        this.inspirationMenu.addEventListener('click', (event) => {
          this.handleInspirationMenuClick(event);
        });
      }

      document.addEventListener('click', (event) => {
        if (
          this.inspirationPicker &&
          !this.inspirationPicker.contains(event.target)
        ) {
          this.closeInspirationMenu();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeInspirationMenu();
        }
      });

      if (this.inspirationGenerateButton) {
        this.inspirationGenerateButton.addEventListener(
          'click',
          this.handleInspirationGenerate
        );
      }

      if (this.colorRangeInput) {
        this.colorRangeInput.addEventListener(
          'input',
          this.handleColorRangeInput
        );
      }

      if (this.saturationInput) {
        this.saturationInput.addEventListener(
          'input',
          this.handleSaturationInput
        );
      }

      if (this.lightnessInput) {
        this.lightnessInput.addEventListener(
          'input',
          this.handleLightnessInput
        );
      }

      if(this.mobileClose){

        this.mobileClose.addEventListener(
          'click',
          ()=>{
            this.closeMobilePicker();

          }
        );
      }
    }


    ensureInspirationControls() {
      if (!this.inspirationMenu) {
        return;
      }

      this.inspirationMenu.innerHTML = '';

      Object.entries(this.inspirationThemes).forEach(
        ([themeKey, theme]) => {
          const group = document.createElement('div');
          group.className = 'lytexa-color-lab__inspiration-group';
          group.dataset.inspirationGroup = themeKey;

          const heading = document.createElement('button');
          heading.type = 'button';
          heading.className = 'lytexa-color-lab__inspiration-group-button';
          heading.dataset.inspirationGroupToggle = themeKey;
          heading.setAttribute('aria-expanded', 'false');
          heading.innerHTML = `
            <span class="lytexa-color-lab__inspiration-dot" aria-hidden="true">•</span>
            <span>${theme.label}</span>
            <span class="lytexa-color-lab__inspiration-chevron" aria-hidden="true">⌄</span>
          `;

          const items = document.createElement('div');
          items.className = 'lytexa-color-lab__inspiration-items';
          items.dataset.inspirationItems = themeKey;
          items.hidden = true;

          theme.swatches.forEach((swatch, swatchIndex) => {
            const value = `${themeKey}::${swatchIndex}`;
            const item = document.createElement('button');
            item.type = 'button';
            item.className = 'lytexa-color-lab__inspiration-item';
            item.dataset.inspirationValue = value;
            item.dataset.inspirationLabel = swatch.name;
            item.textContent = swatch.name;
            items.appendChild(item);
          });

          group.appendChild(heading);
          group.appendChild(items);
          this.inspirationMenu.appendChild(group);
        }
      );
    }

    toggleInspirationMenu() {
      if (!this.inspirationMenu || !this.inspirationButton) {
        return;
      }

      const willOpen = this.inspirationMenu.hidden;
      this.inspirationMenu.hidden = !willOpen;
      this.inspirationButton.setAttribute(
        'aria-expanded',
        willOpen ? 'true' : 'false'
      );
    }

    closeInspirationMenu() {
      if (!this.inspirationMenu || !this.inspirationButton) {
        return;
      }

      this.inspirationMenu.hidden = true;
      this.inspirationButton.setAttribute('aria-expanded', 'false');
    }

    openInspirationTheme(themeKey) {
      if (!this.inspirationMenu) {
        return;
      }

      this.openInspirationGroup =
        this.openInspirationGroup === themeKey ? '' : themeKey;

      this.inspirationMenu
        .querySelectorAll('[data-inspiration-group-toggle]')
        .forEach((button) => {
          const isOpen =
            button.dataset.inspirationGroupToggle ===
            this.openInspirationGroup;
          button.setAttribute(
            'aria-expanded',
            isOpen ? 'true' : 'false'
          );
        });

      this.inspirationMenu
        .querySelectorAll('[data-inspiration-items]')
        .forEach((items) => {
          items.hidden =
            items.dataset.inspirationItems !==
            this.openInspirationGroup;
        });
    }

    handleInspirationMenuClick(event) {
      const groupButton = event.target.closest(
        '[data-inspiration-group-toggle]'
      );

      if (groupButton) {
        this.openInspirationTheme(
          groupButton.dataset.inspirationGroupToggle
        );
        return;
      }

      const item = event.target.closest(
        '[data-inspiration-value]'
      );

      if (!item) {
        return;
      }

      this.setInspirationSelection(
        item.dataset.inspirationValue,
        item.dataset.inspirationLabel,
        true
      );
    }

    setInspirationSelection(value, label, generate = false) {
      this.inspirationTheme = value || 'random';

      if (this.inspirationLabel) {
        this.inspirationLabel.textContent =
          label || 'Choose Inspiration';
      }

      if (this.inspirationMenu) {
        this.inspirationMenu
          .querySelectorAll('[data-inspiration-value]')
          .forEach((item) => {
            item.classList.toggle(
              'is-selected',
              item.dataset.inspirationValue ===
                this.inspirationTheme
            );
          });
      }

      this.closeInspirationMenu();

      if (generate) {
        this.generateInspirationPalette();
      }
    }

    ensureActionButtonLayout() {
      /* Layout is defined directly in the Liquid markup and CSS. */
    }

    handleInspirationGenerate() {
      this.generateInspirationPalette();
    }

    handleColorRangeInput(event) {
      this.colorRangeDegrees = Number(event?.target?.value || 0);
      this.applyPaletteAdjustments();
    }

    handleSaturationInput(event) {
      this.saturationAdjustment = Number(event?.target?.value || 0);
      this.applyPaletteAdjustments();
    }

    handleLightnessInput(event) {
      this.lightnessAdjustment = Number(event?.target?.value || 0);
      this.applyPaletteAdjustments();
    }

    generateInspirationPalette() {
      const selections = [];

      Object.entries(this.inspirationThemes).forEach(
        ([themeKey, theme]) => {
          theme.swatches.forEach((swatch, swatchIndex) => {
            selections.push({
              key: `${themeKey}::${swatchIndex}`,
              theme,
              swatch
            });
          });
        }
      );

      let selection = selections.find(
        (item) => item.key === this.inspirationTheme
      );

      if (!selection) {
        const alternatives = selections.filter(
          (item) => item.key !== this.lastInspirationKey
        );
        selection = alternatives[
          Math.floor(Math.random() * alternatives.length)
        ] || selections[0];
      }

      if (!selection) {
        return;
      }

      const colors = this.generateSwatchPalette(
        selection.swatch,
        this.layers.length,
        selection.theme.minimumDistance
      );

      this.lastInspirationKey = selection.key;
      this.applyPalette(colors);
    }

    randomBetween(minimum, maximum) {
      return minimum + Math.random() * (maximum - minimum);
    }

    shuffle(items) {
      const shuffled = [...items];

      for (let index = shuffled.length - 1; index > 0; index -= 1) {
        const target = Math.floor(Math.random() * (index + 1));
        [shuffled[index], shuffled[target]] = [
          shuffled[target],
          shuffled[index]
        ];
      }

      return shuffled;
    }

    sampleSwatch(swatch) {
      const hue = Array.isArray(swatch.h)
        ? this.randomBetween(swatch.h[0], swatch.h[1])
        : swatch.h;
      const saturation = this.randomBetween(
        swatch.s[0],
        swatch.s[1]
      );
      const lightness = this.randomBetween(
        swatch.l[0],
        swatch.l[1]
      );

      return {
        h: ((hue % 360) + 360) % 360,
        s: saturation,
        l: lightness,
        hex: this.hslToHex(hue, saturation, lightness)
      };
    }

    paletteColorDistance(first, second) {
      const rawHueDistance = Math.abs(first.h - second.h);
      const hueDistance = Math.min(
        rawHueDistance,
        360 - rawHueDistance
      ) / 180;
      const saturationDistance = Math.abs(first.s - second.s) / 100;
      const lightnessDistance = Math.abs(first.l - second.l) / 100;

      return (
        hueDistance * 0.48 +
        saturationDistance * 0.20 +
        lightnessDistance * 0.32
      );
    }

    generateSwatchPalette(
      swatch,
      colorCount,
      minimumDistance = 0.08
    ) {
      if (!swatch || colorCount <= 0) {
        return this.createInitialPalette(colorCount);
      }

      const hueRange = Array.isArray(swatch.h)
        ? swatch.h
        : [swatch.h, swatch.h];
      const saturationRange = [
        Math.max(0, swatch.s[0] - 12),
        Math.min(100, swatch.s[1] + 10)
      ];
      const lightnessRange = [
        Math.max(3, swatch.l[0] - 14),
        Math.min(97, swatch.l[1] + 32)
      ];
      const selected = [];
      const slots = Math.max(1, colorCount - 1);

      for (let index = 0; index < colorCount; index += 1) {
        const progress = slots ? index / slots : 0.5;
        const targetLightness =
          lightnessRange[0] +
          (lightnessRange[1] - lightnessRange[0]) * progress;
        let candidate = null;

        for (let attempt = 0; attempt < 30; attempt += 1) {
          const hue = this.randomBetween(hueRange[0], hueRange[1]);
          const saturation = this.randomBetween(
            saturationRange[0],
            saturationRange[1]
          );
          const lightness = Math.max(
            lightnessRange[0],
            Math.min(
              lightnessRange[1],
              targetLightness + this.randomBetween(-7, 7)
            )
          );
          const sampled = {
            h: ((hue % 360) + 360) % 360,
            s: saturation,
            l: lightness,
            hex: this.hslToHex(hue, saturation, lightness)
          };
          const distinct = selected.every(
            (color) =>
              this.paletteColorDistance(color, sampled) >= minimumDistance
          );

          if (distinct || attempt === 29) {
            candidate = sampled;
            break;
          }
        }

        if (candidate) {
          selected.push(candidate);
        }
      }

      return this.shuffle(selected)
        .slice(0, colorCount)
        .map((color) => color.hex);
    }

    generateThemePalette(theme, colorCount) {
      if (!theme || !Array.isArray(theme.swatches) || colorCount <= 0) {
        return this.createInitialPalette(colorCount);
      }

      const swatches = this.shuffle(theme.swatches);
      const selected = [];
      const minimumDistance = theme.minimumDistance ?? 0.13;

      const addFromSwatch = (swatch, force = false) => {
        let candidate = null;

        for (let attempt = 0; attempt < 24; attempt += 1) {
          const sampled = this.sampleSwatch(swatch);
          const distinct = selected.every(
            (color) =>
              this.paletteColorDistance(color, sampled) >= minimumDistance
          );

          if (distinct || force || attempt === 23) {
            candidate = sampled;
            break;
          }
        }

        if (candidate) {
          selected.push(candidate);
        }
      };

      const lightSwatch = [...theme.swatches].sort(
        (a, b) => b.l[1] - a.l[1]
      )[0];
      const darkSwatch = [...theme.swatches].sort(
        (a, b) => a.l[0] - b.l[0]
      )[0];

      addFromSwatch(lightSwatch, true);

      if (colorCount > 1) {
        addFromSwatch(darkSwatch, true);
      }

      const remainingSwatches = swatches.filter(
        (swatch) => swatch !== lightSwatch && swatch !== darkSwatch
      );

      let swatchIndex = 0;
      while (selected.length < colorCount) {
        const source = remainingSwatches.length
          ? remainingSwatches[swatchIndex % remainingSwatches.length]
          : swatches[swatchIndex % swatches.length];
        addFromSwatch(source);
        swatchIndex += 1;
      }

      return this.shuffle(selected)
        .slice(0, colorCount)
        .map((color) => color.hex);
    }

    getInspirationThemes() {
      const swatch = (name, h, s, l) => ({name, h, s, l});

      return {
        camouflage: {
          label: 'Camouflage',
          minimumDistance: 0.10,
          swatches: [
            swatch('Military Green', [82, 102], [28, 50], [20, 36]),
            swatch('Olive', [58, 78], [28, 55], [28, 48]),
            swatch('Moss', [88, 118], [22, 48], [22, 42]),
            swatch('Khaki', [42, 58], [25, 48], [48, 67]),
            swatch('Sand', [35, 48], [28, 58], [67, 82]),
            swatch('Brown', [20, 35], [30, 55], [22, 40]),
            swatch('Bark', [18, 30], [24, 44], [16, 31]),
            swatch('Black', [45, 90], [4, 16], [7, 17])
          ]
        },
        maritime: {
          label: 'Maritime',
          swatches: [
            swatch('Navy', [205, 225], [58, 88], [12, 27]),
            swatch('Ocean Blue', [195, 215], [55, 82], [30, 49]),
            swatch('Aqua', [176, 192], [48, 78], [45, 66]),
            swatch('Sky Blue', [195, 210], [45, 75], [66, 82]),
            swatch('White', [185, 220], [3, 18], [94, 99]),
            swatch('Sand', [35, 47], [28, 55], [72, 86]),
            swatch('Coral', [5, 18], [62, 85], [52, 68]),
            swatch('Seafoam', [155, 175], [30, 58], [68, 84])
          ]
        },
        autumn: {
          label: 'Autumn',
          swatches: [
            swatch('Rust', [8, 20], [55, 78], [32, 50]),
            swatch('Ochre', [38, 49], [62, 86], [38, 58]),
            swatch('Mustard', [44, 55], [55, 80], [42, 61]),
            swatch('Olive', [62, 83], [28, 52], [27, 46]),
            swatch('Clay', [16, 28], [38, 62], [45, 63]),
            swatch('Walnut', [22, 34], [32, 55], [22, 38]),
            swatch('Chocolate', [15, 28], [40, 66], [13, 29]),
            swatch('Cream', [38, 52], [34, 65], [82, 94])
          ]
        },
        spring: {
          label: 'Spring',
          swatches: [
            swatch('Fresh Green', [88, 122], [48, 76], [42, 64]),
            swatch('Blossom Pink', [338, 355], [48, 78], [70, 86]),
            swatch('Lemon', [50, 61], [70, 94], [65, 83]),
            swatch('Sky Blue', [195, 212], [48, 78], [68, 84]),
            swatch('Mint', [145, 166], [38, 68], [69, 86]),
            swatch('White', [40, 80], [5, 20], [95, 99]),
            swatch('Lilac', [260, 285], [35, 68], [70, 87]),
            swatch('Peach', [16, 30], [62, 88], [72, 87])
          ]
        },
        desert: {
          label: 'Desert',
          minimumDistance: 0.10,
          swatches: [
            swatch('Sand', [34, 47], [28, 58], [67, 84]),
            swatch('Dune', [28, 41], [25, 48], [54, 72]),
            swatch('Clay', [14, 27], [38, 62], [42, 60]),
            swatch('Terracotta', [8, 20], [52, 76], [38, 58]),
            swatch('Warm Grey', [25, 45], [7, 22], [43, 63]),
            swatch('Stone', [30, 55], [9, 25], [58, 76]),
            swatch('Camel', [28, 40], [38, 63], [42, 61]),
            swatch('Dust', [15, 32], [18, 38], [61, 78])
          ]
        },
        nordic: {
          label: 'Nordic',
          minimumDistance: 0.09,
          swatches: [
            swatch('Off White', [35, 60], [8, 28], [91, 98]),
            swatch('Cool Grey', [195, 225], [6, 20], [61, 78]),
            swatch('Sage', [88, 122], [14, 34], [52, 69]),
            swatch('Dust Blue', [195, 215], [20, 42], [53, 70]),
            swatch('Charcoal', [190, 220], [5, 18], [17, 31]),
            swatch('Linen', [35, 48], [18, 38], [78, 91]),
            swatch('Fog', [185, 215], [8, 22], [75, 88]),
            swatch('Graphite', [200, 225], [5, 17], [27, 41])
          ]
        },
        tropical: {
          label: 'Tropical',
          swatches: [
            swatch('Emerald', [137, 158], [55, 82], [28, 48]),
            swatch('Palm Green', [105, 135], [45, 76], [26, 46]),
            swatch('Turquoise', [172, 190], [62, 90], [40, 61]),
            swatch('Mango', [32, 48], [78, 98], [51, 69]),
            swatch('Hibiscus', [338, 356], [68, 92], [48, 66]),
            swatch('Lagoon', [185, 200], [60, 88], [34, 55]),
            swatch('Lime', [78, 100], [65, 90], [45, 64]),
            swatch('Orchid', [287, 316], [48, 78], [52, 72])
          ]
        },
        botanical: {
          label: 'Botanical',
          minimumDistance: 0.10,
          swatches: [
            swatch('Moss', [88, 112], [25, 50], [22, 41]),
            swatch('Fern', [108, 132], [38, 66], [29, 49]),
            swatch('Olive', [60, 82], [28, 52], [30, 48]),
            swatch('Leaf Green', [90, 118], [48, 76], [34, 55]),
            swatch('Eucalyptus', [145, 172], [18, 42], [49, 68]),
            swatch('Sage', [88, 112], [18, 38], [56, 73]),
            swatch('Cream', [38, 55], [28, 58], [84, 95]),
            swatch('Bark', [18, 31], [27, 48], [20, 37])
          ]
        },
        earthTones: {
          label: 'Earth Tones',
          minimumDistance: 0.10,
          swatches: [
            swatch('Clay', [14, 27], [38, 62], [42, 60]),
            swatch('Taupe', [25, 42], [12, 30], [43, 61]),
            swatch('Cocoa', [18, 30], [30, 53], [24, 42]),
            swatch('Olive', [61, 83], [25, 48], [30, 48]),
            swatch('Beige', [35, 49], [25, 52], [68, 84]),
            swatch('Stone', [30, 50], [8, 24], [55, 72]),
            swatch('Walnut', [22, 34], [34, 57], [21, 38]),
            swatch('Camel', [28, 40], [38, 62], [45, 63])
          ]
        },
        pastel: {
          label: 'Pastel',
          minimumDistance: 0.08,
          swatches: [
            swatch('Powder Blue', [198, 215], [36, 65], [76, 90]),
            swatch('Mint', [145, 166], [34, 62], [76, 90]),
            swatch('Peach', [16, 31], [55, 80], [76, 90]),
            swatch('Lavender', [258, 282], [32, 60], [77, 91]),
            swatch('Rose', [340, 355], [42, 68], [77, 90]),
            swatch('Cream', [38, 55], [34, 64], [88, 97]),
            swatch('Pistachio', [78, 102], [32, 60], [74, 88]),
            swatch('Soft Yellow', [49, 60], [55, 80], [79, 91])
          ]
        },
        monochrome: {
          label: 'Monochrome',
          minimumDistance: 0.08,
          swatches: [
            swatch('White', [0, 360], [0, 5], [96, 100]),
            swatch('Light Grey', [0, 360], [0, 6], [76, 90]),
            swatch('Mid Grey', [0, 360], [0, 7], [48, 66]),
            swatch('Graphite', [0, 360], [0, 8], [27, 42]),
            swatch('Anthracite', [0, 360], [0, 8], [14, 28]),
            swatch('Black', [0, 360], [0, 5], [2, 10])
          ]
        },
        vintage: {
          label: 'Vintage / Retro',
          swatches: [
            swatch('Mustard', [42, 55], [52, 78], [38, 58]),
            swatch('Petrol', [178, 199], [42, 68], [25, 45]),
            swatch('Burnt Orange', [17, 29], [60, 82], [38, 57]),
            swatch('Teal', [165, 186], [38, 66], [31, 51]),
            swatch('Cream', [39, 53], [34, 64], [82, 94]),
            swatch('Chocolate', [16, 29], [38, 64], [17, 33]),
            swatch('Olive', [63, 82], [28, 53], [29, 47]),
            swatch('Burgundy', [342, 357], [42, 66], [22, 40])
          ]
        },
        mediterranean: {
          label: 'Mediterranean',
          swatches: [
            swatch('White', [35, 65], [4, 18], [95, 100]),
            swatch('Azure', [197, 215], [62, 88], [40, 61]),
            swatch('Olive', [62, 83], [30, 54], [30, 49]),
            swatch('Terracotta', [9, 21], [52, 76], [42, 61]),
            swatch('Lemon', [50, 61], [72, 94], [59, 78]),
            swatch('Sky', [195, 211], [50, 78], [68, 84]),
            swatch('Aqua', [176, 192], [52, 80], [49, 69]),
            swatch('Stone', [28, 48], [10, 25], [62, 79])
          ]
        },
        luxury: {
          label: 'Luxury',
          swatches: [
            swatch('Ivory', [38, 52], [25, 55], [89, 98]),
            swatch('Champagne', [38, 49], [34, 62], [71, 87]),
            swatch('Gold', [42, 51], [55, 82], [40, 61]),
            swatch('Camel', [28, 40], [38, 62], [43, 61]),
            swatch('Deep Green', [135, 162], [38, 68], [14, 31]),
            swatch('Espresso', [17, 29], [30, 54], [10, 24]),
            swatch('Black', [0, 360], [0, 8], [2, 10]),
            swatch('Burgundy', [342, 357], [42, 68], [19, 37])
          ]
        },
        industrial: {
          label: 'Industrial',
          minimumDistance: 0.09,
          swatches: [
            swatch('Concrete', [190, 220], [2, 12], [55, 72]),
            swatch('Steel', [195, 220], [8, 23], [38, 57]),
            swatch('Zinc', [185, 210], [4, 16], [67, 81]),
            swatch('Graphite', [195, 225], [4, 14], [22, 38]),
            swatch('Rust', [10, 23], [50, 74], [33, 52]),
            swatch('Iron', [190, 215], [4, 13], [15, 29]),
            swatch('Slate', [200, 225], [10, 25], [28, 47]),
            swatch('Charcoal', [190, 220], [4, 14], [10, 24])
          ]
        }
      };
    }

    hexToHsl(hex) {
      const normalized = this.normalizeHexColor(hex);
      const red = parseInt(normalized.slice(1, 3), 16) / 255;
      const green = parseInt(normalized.slice(3, 5), 16) / 255;
      const blue = parseInt(normalized.slice(5, 7), 16) / 255;

      const maximum = Math.max(red, green, blue);
      const minimum = Math.min(red, green, blue);
      const difference = maximum - minimum;
      const lightness = (maximum + minimum) / 2;

      let hue = 0;
      let saturation = 0;

      if (difference !== 0) {
        saturation = difference / (1 - Math.abs(2 * lightness - 1));

        if (maximum === red) {
          hue = 60 * (((green - blue) / difference) % 6);
        } else if (maximum === green) {
          hue = 60 * ((blue - red) / difference + 2);
        } else {
          hue = 60 * ((red - green) / difference + 4);
        }
      }

      if (hue < 0) {
        hue += 360;
      }

      return {
        h: hue,
        s: saturation * 100,
        l: lightness * 100
      };
    }

    hslToHex(hue, saturation, lightness) {
      const h = ((hue % 360) + 360) % 360;
      const s = Math.max(0, Math.min(100, saturation)) / 100;
      const l = Math.max(0, Math.min(100, lightness)) / 100;
      const chroma = (1 - Math.abs(2 * l - 1)) * s;
      const section = h / 60;
      const secondary = chroma * (1 - Math.abs((section % 2) - 1));

      let red = 0;
      let green = 0;
      let blue = 0;

      if (section < 1) {
        red = chroma;
        green = secondary;
      } else if (section < 2) {
        red = secondary;
        green = chroma;
      } else if (section < 3) {
        green = chroma;
        blue = secondary;
      } else if (section < 4) {
        green = secondary;
        blue = chroma;
      } else if (section < 5) {
        red = secondary;
        blue = chroma;
      } else {
        red = chroma;
        blue = secondary;
      }

      const match = l - chroma / 2;
      const toHex = (value) =>
        Math.round((value + match) * 255)
          .toString(16)
          .padStart(2, '0');

      return `#${toHex(red)}${toHex(green)}${toHex(blue)}`;
    }

    handleReset() {
      this.applyPalette(
        this.initialColors
      );

      this.showSaveMessage(
        'The original palette has been restored.'
      );
    }

    async handleDownload() {
      const palette = this.getCurrentPalette();
      const text = palette
        .map((color) => color.toUpperCase())
        .join('\n');

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          textarea.style.pointerEvents = 'none';

          document.body.appendChild(textarea);
          textarea.select();

          const copied = document.execCommand('copy');
          textarea.remove();

          if (!copied) {
            throw new Error('Clipboard copy was not successful.');
          }
        }

        this.showSaveMessage(
          `${palette.length} colors copied to clipboard.`
        );

        if (this.downloadButton) {
          const originalText = this.downloadButton.textContent;
          this.downloadButton.textContent = 'Copied';

          window.setTimeout(() => {
            this.downloadButton.textContent = originalText;
          }, 1400);
        }
      } catch (error) {
        console.error(
          'LYTEXA Color Lab clipboard error:',
          error
        );

        this.showSaveMessage(
          'Could not copy colors. Please try again.'
        );
      }
    }

    updateProductLinks(handle) {
      const root = window.Shopify?.routes?.root || '/';
      const productUrl = `${root}products/${encodeURIComponent(handle)}`;

      if (this.backLink) {
        this.backLink.href = productUrl;
      }

      if (this.productActions) {
        this.productActions.hidden = false;
      }
    }

    async handleLicenseClick(event) {
      event.preventDefault();

      if (!this.productHandle || !this.licenseLink) {
        return;
      }

      const originalLabel = this.licenseLink.textContent;
      this.licenseLink.disabled = true;
      this.licenseLink.textContent = 'Adding…';

      try {
        const root = window.Shopify?.routes?.root || '/';
        const productResponse = await fetch(
          `${root}products/${encodeURIComponent(this.productHandle)}.js`,
          { headers: { Accept: 'application/json' } }
        );

        if (!productResponse.ok) {
          throw new Error('The design could not be loaded.');
        }

        const product = await productResponse.json();
        const variant = Array.isArray(product.variants)
          ? product.variants.find((item) => item.available) || product.variants[0]
          : null;

        if (!variant?.id) {
          throw new Error('This design is currently unavailable.');
        }

        const cartResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: 1 }]
          })
        });

        if (!cartResponse.ok) {
          const errorData = await cartResponse.json().catch(() => ({}));
          throw new Error(errorData.description || 'The design could not be added to the cart.');
        }

        window.location.assign(`${root}cart`);
      } catch (error) {
        this.showSaveMessage(error.message || 'The design could not be added to the cart.', true);
        this.licenseLink.disabled = false;
        this.licenseLink.textContent = originalLabel;
      }
    }

    showSaveMessage(message, isError = false) {
      if (!this.saveMessage) {
        return;
      }

      this.saveMessage.hidden = false;
      this.saveMessage.textContent = message;
      this.saveMessage.classList.toggle('is-error', isError);

      window.clearTimeout(this.saveMessageTimer);
      this.saveMessageTimer = window.setTimeout(() => {
        this.saveMessage.hidden = true;
      }, 3500);
    }

    /*
    |--------------------------------------------------------------------------
    | Palette anwenden
    |--------------------------------------------------------------------------
    */

    applyPalette(colors) {
      const normalizedColors =
        this.validatePalette(colors);

      this.colors = [
        ...normalizedColors
      ];

      this.setColorRangeBase(normalizedColors, true);
      this.updateColorControls();
      this.render();
      this.notifyPaletteChange();
    }

    /*
    |--------------------------------------------------------------------------
    | Palette adjustments – Color Range, Saturation and Lightness
    |--------------------------------------------------------------------------
    */

    setColorRangeBase(colors = this.colors, resetControl = true) {
      const normalizedColors = this.validatePalette(colors);

      this.rangeBaseColors = [
        ...normalizedColors
      ];

      if (resetControl) {
        this.colorRangeDegrees = 0;
        this.saturationAdjustment = 0;
        this.lightnessAdjustment = 0;

        if (this.colorRangeInput) {
          this.colorRangeInput.value = '0';
        }

        if (this.saturationInput) {
          this.saturationInput.value = '0';
        }

        if (this.lightnessInput) {
          this.lightnessInput.value = '0';
        }

        this.updateColorRangeValue(0);
        this.updateSignedValue(this.saturationValue, 0);
        this.updateSignedValue(this.lightnessValue, 0);
      }
    }

    updateColorRangeValue(degrees) {
      if (!this.colorRangeValue) {
        return;
      }

      const rounded = Math.round(Number(degrees) || 0);
      const prefix = rounded > 0 ? '+' : '';
      this.colorRangeValue.textContent = `${prefix}${rounded}°`;
    }

    updateSignedValue(element, value) {
      if (!element) {
        return;
      }

      const rounded = Math.round(Number(value) || 0);
      const prefix = rounded > 0 ? '+' : '';
      element.textContent = `${prefix}${rounded}`;
    }

    applyColorRange(degrees) {
      this.colorRangeDegrees = Number(degrees) || 0;
      this.applyPaletteAdjustments();
    }

    applyPaletteAdjustments() {
      if (!Array.isArray(this.rangeBaseColors) || !this.rangeBaseColors.length) {
        this.setColorRangeBase(this.colors, false);
      }

      const hueShift = Math.max(
        -180,
        Math.min(180, Number(this.colorRangeDegrees) || 0)
      );

      const saturationShift = Math.max(
        -100,
        Math.min(100, Number(this.saturationAdjustment) || 0)
      );

      const lightnessShift = Math.max(
        -100,
        Math.min(100, Number(this.lightnessAdjustment) || 0)
      );

      this.colorRangeDegrees = hueShift;
      this.saturationAdjustment = saturationShift;
      this.lightnessAdjustment = lightnessShift;

      this.updateColorRangeValue(hueShift);
      this.updateSignedValue(this.saturationValue, saturationShift);
      this.updateSignedValue(this.lightnessValue, lightnessShift);

      this.colors = this.rangeBaseColors.map((color) => {
        const hsl = this.hexToHsl(color);
        const shiftedHue = ((hsl.h + hueShift) % 360 + 360) % 360;

        const adjustedSaturation = saturationShift >= 0
          ? hsl.s + (100 - hsl.s) * (saturationShift / 100)
          : hsl.s * (1 + saturationShift / 100);

        const adjustedLightness = lightnessShift >= 0
          ? hsl.l + (100 - hsl.l) * (lightnessShift / 100)
          : hsl.l * (1 + lightnessShift / 100);

        return this.hslToHex(
          shiftedHue,
          Math.max(0, Math.min(100, adjustedSaturation)),
          Math.max(0, Math.min(100, adjustedLightness))
        );
      });

      this.updateColorControls();
      this.render();
      this.notifyPaletteChange();
    }

    commitCurrentPaletteAsRangeBase() {
      this.setColorRangeBase(this.colors, true);
    }

    /*
    |--------------------------------------------------------------------------
    | Reset-Ausgangspalette festlegen
    |--------------------------------------------------------------------------
    */

    setInitialPalette(colors) {
      const normalizedColors =
        this.validatePalette(colors);

      this.initialColors = [
        ...normalizedColors
      ];
    }

    /*
    |--------------------------------------------------------------------------
    | Aktuell sichtbare Palette
    |--------------------------------------------------------------------------
    |
    | Diese Methode wird von AI History und My Color Library verwendet.
    | Sie liefert auch manuell geänderte Farben.
    |
    */

    getCurrentPalette() {
      return [
        ...this.colors
      ];
    }

    /*
    |--------------------------------------------------------------------------
    | Abwärtskompatibilität
    |--------------------------------------------------------------------------
    */

    getColors() {
      return this.getCurrentPalette();
    }

    getLayerCount() {
      return this.layers.length;
    }

    /*
    |--------------------------------------------------------------------------
    | Farbänderung an andere Module melden
    |--------------------------------------------------------------------------
    */

    notifyPaletteChange() {
      const palette =
        this.getCurrentPalette();

      const colorAI =
        this.root.lytexaColorAI;

      /*
      |--------------------------------------------------------------------------
      | Direkte Synchronisierung mit dem Library-Script
      |--------------------------------------------------------------------------
      */

      if (
        colorAI &&
        typeof colorAI.setCurrentPalette ===
          'function'
      ) {
        const currentPrompt =
          typeof colorAI.currentPrompt ===
            'string'
            ? colorAI.currentPrompt
            : '';

        colorAI.setCurrentPalette(
          palette,
          currentPrompt
        );
      }

      /*
      |--------------------------------------------------------------------------
      | Zusätzlich ein neutrales Browser-Ereignis auslösen
      |--------------------------------------------------------------------------
      */

      this.root.dispatchEvent(
        new CustomEvent(
          'lytexa:palette-change',
          {
            bubbles: true,
            detail: {
              colors: palette
            }
          }
        )
      );
    }

    createInitialPalette(colorCount) {
      return Array.from(
        {
          length: colorCount
        },
        (_, index) => {
          return DEFAULT_PALETTE[
            index %
            DEFAULT_PALETTE.length
          ];
        }
      );
    }

    validatePalette(colors) {
      if (!Array.isArray(colors)) {
        throw new Error(
          'The color palette is invalid.'
        );
      }

      if (
        colors.length !==
        this.layers.length
      ) {
        throw new Error(
          'The color palette contains the wrong number of colors.'
        );
      }

      return colors.map((color) => {
        const normalizedColor =
          this.normalizeHexColor(color);

        if (!normalizedColor) {
          throw new Error(
            'The color palette contains an invalid HEX color.'
          );
        }

        return normalizedColor;
      });
    }

    updateColorControls() {
      const colorInputs =
        this.colorsElement.querySelectorAll(
          '.lytexa-color-lab__color-input'
        );

      const hexInputs =
        this.colorsElement.querySelectorAll(
          '.lytexa-color-lab__hex-input'
        );

      this.colors.forEach(
        (color, index) => {
          if (colorInputs[index]) {
            colorInputs[index].value =
              color;
          }

          if (hexInputs[index]) {
            hexInputs[index].value =
              color.toUpperCase();
          }
        }
      );
    }

    getProductHandle() {
      const parameters =
        new URLSearchParams(
          window.location.search
        );

      const handle =
        parameters.get('product');

      if (!handle) {
        return '';
      }

      return handle
        .trim()
        .replace(/^\/+|\/+$/g, '')
        .replace(/^products\//, '');
    }

    async loadProductData(handle) {
      const url =
        `${window.Shopify.routes.root}products/` +
        `${encodeURIComponent(handle)}` +
        '?section_id=lytexa-color-lab-product-data';

      const response =
        await fetch(url, {
          method: 'GET',
          headers: {
            Accept: 'text/html'
          }
        });

      if (!response.ok) {
        throw new Error(
          'The selected design could not be loaded.'
        );
      }

      const html =
        await response.text();

      const parser =
        new DOMParser();

      const documentFragment =
        parser.parseFromString(
          html,
          'text/html'
        );

      const dataElement =
        documentFragment.querySelector(
          '[data-lytexa-color-lab-product-data]'
        );

      if (!dataElement) {
        throw new Error(
          'The Color Lab product data could not be found.'
        );
      }

      try {
        return JSON.parse(
          dataElement.textContent
        );
      } catch (error) {
        throw new Error(
          'The Color Lab product data is invalid.'
        );
      }
    }

    async loadEffectImage(url) {
      return new Promise((resolve, reject) => {
        const image = new Image();

        image.crossOrigin = 'anonymous';

        image.onload = () => {
          resolve({
            image,
            url
          });
        };

        image.onerror = () => {
          reject(
            new Error(
              'The Color Lab effect could not be loaded.'
            )
          );
        };

        image.src = url;
      });
    }

    async loadImages(separations) {
      const promises =
        separations.map(
          (separation) => {
            return new Promise(
              (
                resolve,
                reject
              ) => {
                const image =
                  new Image();

                image.crossOrigin =
                  'anonymous';

                image.onload = () => {
                  resolve({
                    image,
                    position:
                      separation.position
                  });
                };

                image.onerror = () => {
                  reject(
                    new Error(
                      `Separation ${separation.position} could not be loaded.`
                    )
                  );
                };

                image.src =
                  separation.url;
              }
            );
          }
        );

      return Promise.all(promises);
    }

    prepareCanvas() {
      const firstImage =
        this.layers[0].image;

      this.canvas.width =
        firstImage.naturalWidth ||
        firstImage.width ||
        1000;

      this.canvas.height =
        firstImage.naturalHeight ||
        firstImage.height ||
        1000;
    }


    createColorControls() {
      this.colorsElement.innerHTML = '';

      this.layers.forEach(
        (layer, index) => {
          const row =
            document.createElement(
              'div'
            );

          row.className =
            'lytexa-color-lab__color-row';
          row.dataset.colorIndex = String(index);
          row.classList.toggle(
            'is-active',
            index === this.activeColorIndex
          );

          row.addEventListener('click', () => {
            this.activeColorIndex = index;
            this.updateActiveColorControl();
          });

          const number =
            document.createElement(
              'span'
            );

          number.className =
            'lytexa-color-lab__color-number';

          number.textContent =
            `Col ${index + 1}`;

          const colorInput =
            document.createElement(
              'input'
            );

          colorInput.type = 'color';

          colorInput.className =
            'lytexa-color-lab__color-input';

          colorInput.value =
            this.colors[index];

          colorInput.setAttribute(
            'aria-label',
            `Color ${index + 1}`
          );

          const hexInput =
            document.createElement(
              'input'
            );

          hexInput.type = 'text';

          hexInput.className =
            'lytexa-color-lab__hex-input';

          hexInput.value =
            this.colors[
              index
            ].toUpperCase();

          hexInput.maxLength = 7;
          hexInput.spellcheck = false;

          hexInput.setAttribute(
            'aria-label',
            `HEX value for color ${
              index + 1
            }`
          );

          /*
          |--------------------------------------------------------------------------
          | Änderung über Farbwähler
          |--------------------------------------------------------------------------
          */

          colorInput.addEventListener(

              'click',

              ()=>{

                  if(

                     window.innerWidth <= 990

                     &&

                     this.mobilePicker

                  ){

                     this.mobilePicker.hidden = false;

                  }

              }

          );
          
          let holdTimer = null;
          let holdActivated = false;
          let activePointerId = null;
          let allowPickerClick = false;
          let dragActivated = false;
          let dragTargetIndex = null;
          let pointerStartX = 0;
          let pointerStartY = 0;
          const dragThreshold = 8;

          const clearHoldTimer = () => {
            if (holdTimer !== null) {
              window.clearTimeout(holdTimer);
              holdTimer = null;
            }
          };

          const restoreAllLayers = () => {
            if (this.isolatedLayerIndex === null) {
              return;
            }

            this.isolatedLayerIndex = null;
            row.classList.remove('is-isolating');
            this.render();
          };

          const openColorPicker = () => {
            this.activeColorIndex = index;
            this.updateActiveColorControl();

            if (this.isMobilePickerLayout()) {
              this.openMobilePicker(index);
              return;
            }

            if (typeof colorInput.showPicker === 'function') {
              try {
                colorInput.showPicker();
                return;
              } catch (error) {
                console.debug('LYTEXA Color Lab: showPicker unavailable.', error);
              }
            }

            allowPickerClick = true;
            colorInput.click();
            allowPickerClick = false;
          };

          colorInput.addEventListener(
            'pointerdown',
            (event) => {
              if (event.button !== 0 && event.pointerType !== 'touch') {
                return;
              }

              event.preventDefault();
              activePointerId = event.pointerId;
              holdActivated = false;
              dragActivated = false;
              dragTargetIndex = null;
              pointerStartX = event.clientX;
              pointerStartY = event.clientY;

              try {
                colorInput.setPointerCapture(event.pointerId);
              } catch (error) {
                // Pointer capture is optional.
              }

              clearHoldTimer();
              holdTimer = window.setTimeout(() => {
                holdActivated = true;
                this.activeColorIndex = index;
                this.isolatedLayerIndex = index;
                this.updateActiveColorControl();
                row.classList.add('is-isolating');
                this.render();
              }, this.holdDelay);
            }
          );

          colorInput.addEventListener(
            'pointermove',
            (event) => {
              if (activePointerId !== event.pointerId || holdActivated) {
                return;
              }

              const distanceX = event.clientX - pointerStartX;
              const distanceY = event.clientY - pointerStartY;
              const distance = Math.hypot(distanceX, distanceY);

              if (!dragActivated && distance >= dragThreshold) {
                dragActivated = true;
                clearHoldTimer();
                row.classList.add('is-dragging');
                row.style.opacity = '0.65';
                row.style.transform = 'scale(0.98)';
              }

              if (!dragActivated) {
                return;
              }

              const elementBelow = document.elementFromPoint(
                event.clientX,
                event.clientY
              );

              const targetRow = elementBelow
                ? elementBelow.closest('.lytexa-color-lab__color-row')
                : null;

              this.colorsElement
                .querySelectorAll('.lytexa-color-lab__color-row.is-drag-target')
                .forEach((candidate) => {
                  candidate.classList.remove('is-drag-target');
                  candidate.style.outline = '';
                  candidate.style.outlineOffset = '';
                });

              dragTargetIndex = null;

              if (!targetRow) {
                return;
              }

              const targetIndex = Number(targetRow.dataset.colorIndex);

              if (!Number.isInteger(targetIndex) || targetIndex === index) {
                return;
              }

              dragTargetIndex = targetIndex;
              targetRow.classList.add('is-drag-target');
              targetRow.style.outline = '2px solid currentColor';
              targetRow.style.outlineOffset = '2px';
            }
          );

          colorInput.addEventListener(
            'pointerup',
            (event) => {
              if (activePointerId !== event.pointerId) {
                return;
              }

              event.preventDefault();
              clearHoldTimer();

              if (holdActivated) {
                restoreAllLayers();
              } else if (dragActivated) {
                if (
                  Number.isInteger(dragTargetIndex) &&
                  dragTargetIndex !== index
                ) {
                  const sourceColor = this.colors[index];
                  this.colors[index] = this.colors[dragTargetIndex];
                  this.colors[dragTargetIndex] = sourceColor;
                  this.updateColorControls();
                  this.render();
                  this.commitCurrentPaletteAsRangeBase();
                  this.notifyPaletteChange();
                }
              } else {
                openColorPicker();
              }

              this.colorsElement
                .querySelectorAll('.lytexa-color-lab__color-row.is-drag-target')
                .forEach((candidate) => {
                  candidate.classList.remove('is-drag-target');
                  candidate.style.outline = '';
                  candidate.style.outlineOffset = '';
                });

              row.classList.remove('is-dragging');
              row.style.opacity = '';
              row.style.transform = '';
              holdActivated = false;
              dragActivated = false;
              dragTargetIndex = null;
              activePointerId = null;
            }
          );

          colorInput.addEventListener(
            'pointercancel',
            () => {
              clearHoldTimer();
              restoreAllLayers();
              row.classList.remove('is-dragging');
              row.style.opacity = '';
              row.style.transform = '';
              this.colorsElement
                .querySelectorAll('.lytexa-color-lab__color-row.is-drag-target')
                .forEach((candidate) => {
                  candidate.classList.remove('is-drag-target');
                  candidate.style.outline = '';
                  candidate.style.outlineOffset = '';
                });
              holdActivated = false;
              dragActivated = false;
              dragTargetIndex = null;
              activePointerId = null;
            }
          );

          colorInput.addEventListener(
            'lostpointercapture',
            () => {
              clearHoldTimer();

              if (holdActivated) {
                restoreAllLayers();
              }

              row.classList.remove('is-dragging');
              row.style.opacity = '';
              row.style.transform = '';
              this.colorsElement
                .querySelectorAll('.lytexa-color-lab__color-row.is-drag-target')
                .forEach((candidate) => {
                  candidate.classList.remove('is-drag-target');
                  candidate.style.outline = '';
                  candidate.style.outlineOffset = '';
                });
              holdActivated = false;
              dragActivated = false;
              dragTargetIndex = null;
              activePointerId = null;
            }
          );

          colorInput.addEventListener(
            'click',
            (event) => {
              if (allowPickerClick) {
                return;
              }

              event.preventDefault();
            }
          );

          colorInput.addEventListener(
            'input',
            () => {
              const color =
                colorInput.value
                  .toLowerCase();

              this.colors[index] =
                color;

              hexInput.value =
                color.toUpperCase();

              this.render();
              this.commitCurrentPaletteAsRangeBase();
              this.notifyPaletteChange();
            }
          );

          /*
          |--------------------------------------------------------------------------
          | Änderung über HEX-Eingabe
          |--------------------------------------------------------------------------
          */

          hexInput.addEventListener(
            'change',
            () => {
              const color =
                this.normalizeHexColor(
                  hexInput.value
                );

              if (!color) {
                hexInput.value =
                  this.colors[
                    index
                  ].toUpperCase();

                return;
              }

              this.colors[index] =
                color;

              colorInput.value =
                color;

              hexInput.value =
                color.toUpperCase();

              this.render();
              this.commitCurrentPaletteAsRangeBase();
              this.notifyPaletteChange();
            }
          );

          row.appendChild(number);

          row.appendChild(
            colorInput
          );

          row.appendChild(
            hexInput
          );

          this.colorsElement.appendChild(
            row
          );
        }
      );

      if (this.effectLayer) {
        this.createEffectControl();
      }
    }

    createEffectControl() {
      const row = document.createElement('div');
      row.className =
        'lytexa-color-lab__color-row lytexa-color-lab__effect-row';

      const label = document.createElement('span');
      label.className =
        'lytexa-color-lab__color-number';
      label.textContent = 'Effect';

      const button = document.createElement('button');
      button.type = 'button';
      button.className =
        'lytexa-color-lab__effect-button';
      button.setAttribute(
        'aria-label',
        'Toggle Soft Light effect'
      );
      button.setAttribute(
        'aria-pressed',
        String(this.effectEnabled)
      );

      button.style.backgroundImage =
        `url("${this.effectLayer.url}")`;

      button.classList.toggle(
        'is-disabled',
        !this.effectEnabled
      );

      const marker = document.createElement('span');
      marker.className =
        'lytexa-color-lab__effect-marker';
      marker.textContent = 'FX';
      marker.setAttribute('aria-hidden', 'true');

      button.appendChild(marker);

      button.addEventListener('click', () => {
        this.effectEnabled = !this.effectEnabled;

        button.setAttribute(
          'aria-pressed',
          String(this.effectEnabled)
        );

        button.classList.toggle(
          'is-disabled',
          !this.effectEnabled
        );

        this.render();
      });

      row.appendChild(label);
      row.appendChild(button);
      this.colorsElement.appendChild(row);
      this.colorsElement.classList.add('has-effect');
    }

    updateActiveColorControl() {
      this.colorsElement
        ?.querySelectorAll('.lytexa-color-lab__color-row')
        .forEach((row, index) => {
          row.classList.toggle(
            'is-active',
            index === this.activeColorIndex
          );
        });

    }

    normalizeHexColor(value) {
      let normalized =
        String(value || '')
          .trim()
          .toLowerCase();

      if (
        !normalized.startsWith('#')
      ) {
        normalized =
          `#${normalized}`;
      }

      if (
        /^#[0-9a-f]{6}$/.test(
          normalized
        )
      ) {
        return normalized;
      }

      if (
        /^#[0-9a-f]{3}$/.test(
          normalized
        )
      ) {
        return (
          '#' +
          normalized[1] +
          normalized[1] +
          normalized[2] +
          normalized[2] +
          normalized[3] +
          normalized[3]
        );
      }

      return '';
    }

    render() {
      const width =
        this.canvas.width;

      const height =
        this.canvas.height;

      this.context.save();

      this.context.globalAlpha = 1;

      this.context.globalCompositeOperation =
        'source-over';

      this.context.fillStyle =
        '#ffffff';

      this.context.fillRect(
        0,
        0,
        width,
        height
      );

      this.layers.forEach(
        (layer, index) => {
          if (
            this.isolatedLayerIndex !== null &&
            index !== this.isolatedLayerIndex
          ) {
            return;
          }

          const color =
            this.colors[index] ||
            '#ffffff';

          const coloredLayer =
            this.createColoredLayer(
              layer.image,
              color,
              width,
              height
            );

          this.context.globalCompositeOperation =
            'multiply';

          this.context.drawImage(
            coloredLayer,
            0,
            0,
            width,
            height
          );
        }
      );

      if (
        this.effectLayer &&
        this.effectEnabled &&
        this.isolatedLayerIndex === null
      ) {
        this.context.globalAlpha = 1;
        this.context.globalCompositeOperation =
          'soft-light';

        this.context.drawImage(
          this.effectLayer.image,
          0,
          0,
          width,
          height
        );
      }

      this.context.restore();
    }

    createColoredLayer(
      image,
      color,
      width,
      height
    ) {
      const canvas =
        document.createElement(
          'canvas'
        );

      canvas.width = width;
      canvas.height = height;

      const context =
        canvas.getContext('2d');

      context.drawImage(
        image,
        0,
        0,
        width,
        height
      );

      context.globalCompositeOperation =
        'source-in';

      context.fillStyle = color;

      context.fillRect(
        0,
        0,
        width,
        height
      );

      context.globalCompositeOperation =
        'source-over';

      return canvas;
    }

    isMobilePickerLayout() {
      return true;
    }

createMobilePicker() {
  if (
    !this.mobilePicker ||
    !this.mobilePickerHost
  ) {
    return;
  }

  this.mobilePickerHost.innerHTML = `
    <div class="lytexa-mobile-color-picker">

      <div
        class="lytexa-mobile-color-picker__field"
        data-mobile-color-field
        aria-label="Choose saturation and brightness"
      >
        <span
          class="lytexa-mobile-color-picker__field-marker"
          data-mobile-color-field-marker
        ></span>
      </div>

      <div
        class="lytexa-mobile-color-picker__hue"
        data-mobile-color-hue
        aria-label="Choose hue"
      >
        <span
          class="lytexa-mobile-color-picker__hue-marker"
          data-mobile-color-hue-marker
        ></span>
      </div>

      <div class="lytexa-mobile-color-picker__value">
        <span
          class="lytexa-mobile-color-picker__swatch"
          data-mobile-color-swatch
        ></span>

        <strong data-mobile-color-hex>
          #000000
        </strong>


      </div>

    </div>
  `;

  this.mobileColorField =
    this.mobilePickerHost.querySelector(
      '[data-mobile-color-field]'
    );

  this.mobileColorFieldMarker =
    this.mobilePickerHost.querySelector(
      '[data-mobile-color-field-marker]'
    );

  this.mobileHueField =
    this.mobilePickerHost.querySelector(
      '[data-mobile-color-hue]'
    );

  this.mobileHueMarker =
    this.mobilePickerHost.querySelector(
      '[data-mobile-color-hue-marker]'
    );

  this.mobileColorSwatch =
    this.mobilePickerHost.querySelector(
      '[data-mobile-color-swatch]'
    );

  this.mobileColorHex =
    this.mobilePickerHost.querySelector(
      '[data-mobile-color-hex]'
    );

  this.bindMobilePointerControl(
    this.mobileColorField,
    (event) => {
      const rectangle =
        this.mobileColorField.getBoundingClientRect();

      const x = Math.max(
        0,
        Math.min(
          rectangle.width,
          event.clientX - rectangle.left
        )
      );

      const y = Math.max(
        0,
        Math.min(
          rectangle.height,
          event.clientY - rectangle.top
        )
      );

      this.mobileSaturation =
        x / rectangle.width;

      this.mobileValue =
        1 - y / rectangle.height;

      this.updateMobileSelectedColor();
    }
  );

  this.bindMobilePointerControl(
    this.mobileHueField,
    (event) => {
      const rectangle =
        this.mobileHueField.getBoundingClientRect();

      const x = Math.max(
        0,
        Math.min(
          rectangle.width,
          event.clientX - rectangle.left
        )
      );

      this.mobileHue =
        (x / rectangle.width) * 360;

      this.updateMobileSelectedColor();
    }
  );
}

bindMobilePointerControl(element, callback) {
  if (!element) {
    return;
  }

  element.addEventListener(
    'pointerdown',
    (event) => {
      event.preventDefault();

      element.setPointerCapture(
        event.pointerId
      );

      callback(event);
    }
  );

  element.addEventListener(
    'pointermove',
    (event) => {
      if (
        !element.hasPointerCapture(
          event.pointerId
        )
      ) {
        return;
      }

      event.preventDefault();
      callback(event);
    }
  );

  const releasePointer = (event) => {
    if (
      element.hasPointerCapture(
        event.pointerId
      )
    ) {
      element.releasePointerCapture(
        event.pointerId
      );
    }
  };

  element.addEventListener(
    'pointerup',
    releasePointer
  );

  element.addEventListener(
    'pointercancel',
    releasePointer
  );
}

openMobilePicker(index) {
  if (
    !this.mobilePicker ||
    !this.isMobilePickerLayout()
  ) {
    return;
  }

  this.activeMobileColorIndex = index;
  this.activeColorIndex = index;

  const hsv = this.hexToHsv(
    this.colors[index]
  );

  this.mobileHue = hsv.h;
  this.mobileSaturation = hsv.s;
  this.mobileValue = hsv.v;

  this.mobilePicker.hidden = false;

  this.root.classList.add(
    'is-mobile-picker-open'
  );

  this.syncMobilePickerInterface();

  const rows =
    this.colorsElement.querySelectorAll(
      '.lytexa-color-lab__color-row'
    );

  rows.forEach(
    (row, rowIndex) => {
      row.classList.toggle(
        'is-active',
        rowIndex === index
      );
    }
  );
}

closeMobilePicker() {
  if (!this.mobilePicker) {
    return;
  }

  this.mobilePicker.hidden = true;

  this.root.classList.remove(
    'is-mobile-picker-open'
  );

  this.activeMobileColorIndex = null;

  this.updateActiveColorControl();
}

updateMobileSelectedColor() {
  if (
    this.activeMobileColorIndex === null
  ) {
    return;
  }

  const color = this.hsvToHex(
    this.mobileHue,
    this.mobileSaturation,
    this.mobileValue
  );

  this.colors[
    this.activeMobileColorIndex
  ] = color;

  this.updateColorControls();
  this.syncMobilePickerInterface();
  this.render();
  this.commitCurrentPaletteAsRangeBase();
  this.notifyPaletteChange();
}

syncMobilePickerInterface() {
  if (
    !this.mobileColorField ||
    !this.mobileColorFieldMarker ||
    !this.mobileHueMarker
  ) {
    return;
  }

  const color = this.hsvToHex(
    this.mobileHue,
    this.mobileSaturation,
    this.mobileValue
  );

  this.mobileColorField.style.backgroundColor =
    `hsl(${this.mobileHue}, 100%, 50%)`;

  this.mobileColorFieldMarker.style.left =
    `${this.mobileSaturation * 100}%`;

  this.mobileColorFieldMarker.style.top =
    `${(1 - this.mobileValue) * 100}%`;

  this.mobileHueMarker.style.left =
    `${(this.mobileHue / 360) * 100}%`;

  if (this.mobileColorSwatch) {
    this.mobileColorSwatch.style.background =
      color;
  }

  if (this.mobileColorHex) {
    this.mobileColorHex.textContent =
      color.toUpperCase();
  }

}

hexToHsv(hex) {
  const normalized =
    this.normalizeHexColor(hex);

  const red =
    parseInt(normalized.slice(1, 3), 16) / 255;

  const green =
    parseInt(normalized.slice(3, 5), 16) / 255;

  const blue =
    parseInt(normalized.slice(5, 7), 16) / 255;

  const maximum =
    Math.max(red, green, blue);

  const minimum =
    Math.min(red, green, blue);

  const difference =
    maximum - minimum;

  let hue = 0;

  if (difference !== 0) {
    if (maximum === red) {
      hue =
        60 *
        (((green - blue) / difference) % 6);
    } else if (maximum === green) {
      hue =
        60 *
        ((blue - red) / difference + 2);
    } else {
      hue =
        60 *
        ((red - green) / difference + 4);
    }
  }

  if (hue < 0) {
    hue += 360;
  }

  return {
    h: hue,
    s:
      maximum === 0
        ? 0
        : difference / maximum,
    v: maximum
  };
}

hsvToHex(hue, saturation, value) {
  const chroma =
    value * saturation;

  const section =
    hue / 60;

  const second =
    chroma *
    (1 - Math.abs((section % 2) - 1));

  const match =
    value - chroma;

  let red = 0;
  let green = 0;
  let blue = 0;

  if (section >= 0 && section < 1) {
    red = chroma;
    green = second;
  } else if (section < 2) {
    red = second;
    green = chroma;
  } else if (section < 3) {
    green = chroma;
    blue = second;
  } else if (section < 4) {
    green = second;
    blue = chroma;
  } else if (section < 5) {
    red = second;
    blue = chroma;
  } else {
    red = chroma;
    blue = second;
  }

  const toHex = (number) => {
    return Math.round(
      (number + match) * 255
    )
      .toString(16)
      .padStart(2, '0');
  };

  return (
    `#${toHex(red)}` +
    `${toHex(green)}` +
    `${toHex(blue)}`
  );
}
    
    showError(message) {
      if (this.workspaceElement) {
        this.workspaceElement.hidden =
          true;
      }

      if (!this.statusElement) {
        return;
      }

      this.statusElement.hidden =
        false;

      this.statusElement.classList.add(
        'is-error'
      );

      this.statusElement.textContent =
        message;
    }
  }


  /*
  |--------------------------------------------------------------------------
  | Safari / back-forward cache guard
  |--------------------------------------------------------------------------
  | Safari can restore the pre-login guest page from its page cache after the
  | hosted Shopify sign-in flow. A single reload forces Liquid to render the
  | authenticated customer state instead of showing a stale lock overlay.
  */
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) {
      return;
    }

    const lockedLab = document.querySelector(
      '[data-lytexa-color-lab][data-color-lab-locked="true"]'
    );

    if (lockedLab) {
      window.location.reload();
    }
  });

  function startLockedPreview(root, colorLab) {
    if (!root || root.dataset.colorLabLocked !== 'true') {
      return;
    }

    const overlay = root.querySelector('[data-color-lab-lock]');
    const unlockButton = root.querySelector('[data-color-lab-unlock]');
    const themeOrder = ['autumn::0', 'nordic::2', 'mediterranean::1', 'camouflage::0'];
    let themeIndex = 0;
    let chipIndex = 0;

    root.classList.add('is-demo-running');

    const animateChip = () => {
      const chips = root.querySelectorAll('.lytexa-color-lab__color-row');
      chips.forEach((chip) => chip.classList.remove('is-demo-highlight'));

      if (chips.length) {
        chips[chipIndex % chips.length].classList.add('is-demo-highlight');
        chipIndex += 1;
      }
    };

    const changeDemoPalette = () => {
      const theme = themeOrder[themeIndex % themeOrder.length];
      themeIndex += 1;

      colorLab.setInspirationSelection(
        theme,
        '',
        false
      );
      colorLab.generateInspirationPalette();
      animateChip();
    };

    window.setTimeout(changeDemoPalette, 650);

    /* Start the blur early and let it build slowly. */
    window.setTimeout(() => {
      root.classList.add('is-blur-start');
    }, 450);

    /* Reveal the login layer only when its entrance animation begins. */
    window.setTimeout(() => {
      if (overlay) {
        overlay.hidden = false;
        overlay.setAttribute('aria-hidden', 'false');
      }

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          root.classList.add('is-lock-active');
        });
      });
    }, 2200);

    window.setInterval(changeDemoPalette, 4300);
    window.setInterval(animateChip, 900);

    if (unlockButton) {
      unlockButton.addEventListener('pointerdown', (event) => {
        const rect = unlockButton.getBoundingClientRect();
        unlockButton.style.setProperty('--ripple-x', `${event.clientX - rect.left}px`);
        unlockButton.style.setProperty('--ripple-y', `${event.clientY - rect.top}px`);
        unlockButton.classList.remove('is-rippling');
        void unlockButton.offsetWidth;
        unlockButton.classList.add('is-rippling');
      });
    }
  }

  function initializeFoodDeliveryLinks() {
    const storageKey = 'lytexaFoodDeliveryLocation';

    document
      .querySelectorAll('[data-color-lab-food-form]')
      .forEach((form) => {
        if (form.dataset.lytexaFoodDeliveryInitialized === 'true') {
          return;
        }

        form.dataset.lytexaFoodDeliveryInitialized = 'true';

        const input = form.querySelector(
          '[data-color-lab-food-location]'
        );

        if (!input) {
          return;
        }

        try {
          const savedLocation = localStorage.getItem(storageKey);

          if (savedLocation) {
            input.value = savedLocation;
          }
        } catch (error) {
          // Storage can be unavailable in private or restricted browsing.
        }

        form.addEventListener('submit', (event) => {
          event.preventDefault();

          const location = String(input.value || '').trim();

          if (!location) {
            input.focus();
            return;
          }

          try {
            localStorage.setItem(storageKey, location);
          } catch (error) {
            // The search still works when storage is unavailable.
          }

          const query = `food delivery near ${location}`;
          const url =
            'https://www.google.com/maps/search/' +
            '?api=1&query=' +
            encodeURIComponent(query);

          window.open(url, '_blank', 'noopener,noreferrer');
        });
      });
  }

  function initializeColorLabs() {
    const colorLabs =
      document.querySelectorAll(
        '[data-lytexa-color-lab]'
      );

    colorLabs.forEach((root) => {
      if (root.lytexaColorLab) {
        return;
      }

      const colorLab =
        new LytexaColorLab(root);

      root.lytexaColorLab =
        colorLab;

      colorLab.initialize().then(() => {
        startLockedPreview(root, colorLab);
      });
    });
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeColorLabs
    );
  } else {
    initializeColorLabs();
  }

  initializeFoodDeliveryLinks();

  document.addEventListener(
    'shopify:section:load',
    initializeFoodDeliveryLinks
  );
})();






